export default __webpack_public_path__ + "static/media/down-arrow.5c876f14.svg";